import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { WebServiceDataSourceActionEndpointFormlyFieldProp } from "../../model/dyn-form/form-visualizer/formly-group.model";
import { Observable } from "rxjs";


@Injectable({
    providedIn: 'root'
})
export class EFormWebServiceService {

    protected resourceUrl: string = "/rest/publicarea/form-webservice"


    constructor(private http: HttpClient) { }

    public call(filter: WebServiceDataSourceActionEndpointFormlyFieldProp): Observable<{ ok: boolean, messageCode: string, entity: Map<string, any> }> {
		return this.http.post<{ ok: boolean, messageCode: string, entity: Map<string, any> }>(`${this.resourceUrl}/call`, filter)
	}

}